class ServiceChannel {
    constructor(transport) {
        // 移动端无需实现
        this.fire = () => { };
        this.token = ServiceChannel.createToken();
        this.transport = transport;
        ServiceChannel.channels.set(this.token, this);
    }
    static createToken() {
        this.token += 1;
        return this.token;
    }
    static get(token) {
        return this.channels.get(token);
    }
    subscribe(eventName, handler) {
        if (this.isClosed()) {
            throw new Error('channel is closed');
        }
        return this.transport.subscribe(this.token, eventName, handler);
    }
    publish(eventName, ...args) {
        if (this.isClosed()) {
            throw new Error('channel is closed');
        }
        this.transport.publish({
            token: this.token,
            eventName: eventName,
            args,
        });
    }
    close() {
        ServiceChannel.channels.delete(this.token);
        this.transport.unsubscribe(this.token);
    }
    isClosed() {
        return !ServiceChannel.channels.has(this.token);
    }
}
ServiceChannel.token = 0;
ServiceChannel.channels = new Map();
export default ServiceChannel;
//# sourceMappingURL=service-channel.js.map